import PatientForm from "./PatientForm";

export default PatientForm;
